export default __webpack_public_path__ + "static/talcum-116778a3d5237d491784e3f6f5e38887.png";